export const SET_MODALITIES_LOCAL_TRAININGS = 'setModalitiesLocalTrainings'
export const SET_LOCAL_TRAININGS = 'setLocalTrainings'
export const SET_MODALITIES = 'setModalities'
export const CLEAR_LOCAL_TRAININGS = 'clearLocalTrainings'
export const CLEAR_MODALITIES = 'clearModalities'
